export const resolveStatus = (status: string) => {
  const st = status.toLowerCase()
  if (st.includes("error")) return "text-red-600"
  if (["executed", "success", "processed", "charged"].some((item) => st.includes(item))) return "text-green-600"
  if (["processing"].some((item) => st.includes(item))) return "text-orange-500"
  return ""
}
